import { ExperienceTransferItemWire } from 'app/area/experience-transfer/list/types';
import { ExperienceTransferListItem } from 'app/area/experience-transfer/list/types-store';

export const mapList = (listWire: ExperienceTransferItemWire[]): ExperienceTransferListItem[] => {

  if ((listWire?.length ?? 0) === 0) {
    return [];
  }

  return listWire.map(item => ({
    id: item?.id,
    active: item?.active,
    caseTypeDescription: item?.caseType?.d,
    criteriaDescription: item?.criteria?.d,
    criteriaLongDescription: item?.criteria?.ld,
    operationDescription: item?.operation?.d,
    subscriberGroupDescription: item?.subscriberGroup?.d
  }));
};
